import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '../../stores/useAuthStore'

/**
 * Garde de route admin : redirige si non authentifié ou non admin.
 */
export default function AdminRoute({ children }) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  const isInitializing = useAuthStore((s) => s.isInitializing)
  const user = useAuthStore((s) => s.user)
  const location = useLocation()

  if (isInitializing) {
    return (
      <div className="flex items-center justify-center h-screen text-gray-500">
        Chargement...
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/auth" state={{ from: location }} replace />
  }

  if (user?.role !== 'admin') {
    return <Navigate to="/app" replace />
  }

  return children
}
